<template>
  <q-page padding class="container">
    <SelecaoArquivoTela @enviarArquivo="receberArquivo" />
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Documento: {{ detalheDocumento.nome }}
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs items-center"
    >
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div>Nome</div>
        <q-input
          bg-color="brand-7"
          disable
          v-model="detalheDocumento.nome"
          dense
          outlined
        >
        </q-input>
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div>Descrição</div>
        <q-input
          bg-color="brand-7"
          disable
          v-model="detalheDocumento.descricao"
          dense
          outlined
        >
        </q-input>
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div>Categoria</div>
        <q-select
          option-label="nome"
          option-value="uuid"
          bg-color="brand-7"
          disable
          v-model="dados.categoria"
          @filter="filtrarCategoria"
          :options="options.optionsCategoria"
          dense
          outlined
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-italic text-grey">
                Nenhuma categoria encontrada
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <div>Tipo</div>
        <q-select
          option-label="nome"
          option-value="uuid"
          bg-color="brand-7"
          disable
          v-model="dados.tipo"
          @filter="filtrarTipo"
          :options="options.optionsTipo"
          dense
          outlined
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-italic text-grey">
                Nenhum tipo encontrado
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="row col-md-2 col-sm-6 col-xs-6">
        <div class="col-12 q-mr-sm">
          <div class="texto-titulo-input">Data de Emissão</div>
          <q-input
            v-model="data.dataVigencia"
            dense
            bg-color="brand-7"
            disable
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="data.dataVigencia"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row col-md-2 col-sm-5 col-xs-5">
        <div class="col-12 q-mr-sm">
          <div class="texto-titulo-input">Data de Vencimento</div>
          <q-input
            v-model="data.dataVencimento"
            dense
            bg-color="brand-7"
            disable
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="data.dataVencimento"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div>Status</div>
        <q-input
          bg-color="brand-7"
          disable
          v-model="detalheDocumento.status"
          dense
          outlined
        >
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          icon="edit"
          class="q-mt-xs"
          :outline="!rightDrawerOpen"
          no-caps
          label="Editar"
          dense
          color="primary"
          @click="
            (rightDrawerOpen = true),
              (dadosDocumento = { ...detalheDocumento, ...data }),
              (tab = 'editar')
          "
        />
      </div>
      <div>
        <p></p>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <q-btn
            icon="file_upload"
            color="brand-1"
            class="q-mt-xs"
            dense
            outline
            no-caps
            label="Selecionar Arquivo"
            @click="abrirDialogoArquivo()"
          />
        </div>
      </div>
      <div v-if="detalheDocumento.status != 'revalidado'">
        <p></p>
        <q-btn
          icon="edit"
          class="q-mt-xs"
          :outline="!revalidarDocumentoEditar"
          no-caps
          label="Revalidar Documento"
          dense
          color="brand-2"
          @click="revalidarDocumentoEditar = !revalidarDocumentoEditar"
        />
      </div>
      <div v-if="revalidarDocumentoEditar" class="row col-12 q-gutter-sm">
        <div class="row col-md-2 col-sm-5 col-xs-5">
          <div class="col-12 q-mr-sm">
            <div class="texto-titulo-input">Data de Emissao</div>
            <q-input
              v-model="data.dataEmissaoRevalidar"
              dense
              outlined
              class="input"
              placeholder="DD/MM/AAAA"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="data.dataEmissaoRevalidar"
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
        <div class="row col-md-2 col-sm-5 col-xs-5">
          <div class="col-12 q-mr-sm">
            <div class="texto-titulo-input">Data de Vencimento</div>
            <q-input
              v-model="data.dataVencimentoRevalidar"
              dense
              outlined
              class="input"
              placeholder="DD/MM/AAAA"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="data.dataVencimentoRevalidar"
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
        <div>
          <p></p>
          <q-btn
            icon="save"
            class="q-mt-sm"
            no-caps
            label="Salvar"
            dense
            color="positive"
            @click="revalidarDocumento()"
          />
        </div>
      </div>
    </div>
    <div v-if="detalheDocumento?.arquivos?.length > 0" class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Anexos
        </span>
        <div
          class="input-search-table justify-end row col-md-3 col-xs-12 col-sm-12 q-mb-md"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            type="text"
            placeholder="Filtrar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="detalheDocumento.arquivos"
        class="my-sticky-dynamic"
        dense
        color="primary"
        :hide-bottom="!detalheDocumento?.arquivos.length == 0"
        no-data-label="Nenhum arquivo encontrado."
        flat
        table-header-class="bg-accent text-weight-bold"
        :rows-per-page-options="[0]"
        :filter="filter"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="text-brand-5 text-weight-bold">
              {{ props.row.nome }}
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              {{
                props.row?.criadoEm.split(" ")[0].split("-").reverse().join("/")
              }}
            </q-td>
            <q-td>
              <a :href="props.row.url">
                <q-btn round color="brand-5" flat icon="file_download"
              /></a>
            </q-td>
            <q-td>
              <q-btn
                round
                color="red"
                flat
                icon="delete"
                @click="(idArquivo = props.row.uuid), (confirmExcluir = true)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <div class="row col-12 items-center">
          <span
            class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold items-center"
          >
            Lista de Ativos Vinculados
          </span>
          <q-btn
            label="Vincular Novo"
            no-caps
            color="primary"
            icon="build"
            class="q-ml-sm"
            :outline="!modalAtivos"
            @click="modalAtivos = true"
          />
        </div>
      </div>
      <q-table
        :columns="columnsAtivo"
        :rows="listaAtivoVinculado"
        class="my-sticky-dynamic"
        color="primary"
        dense
        key="ativoUuid"
        :hide-bottom="!listaAtivoVinculado.length == 0"
        no-data-label="Nenhum ativo vinculado."
        flat
        table-header-class="bg-accent text-weight-bold"
        :rows-per-page-options="[0]"
        :filter="filter"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-patrimonio="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.patrimonio }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              `${props.row.status
                .charAt(0)
                .toUpperCase()}${props.row.status.substring(1)}`
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-colaborador="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nomeColaborador }}
          </q-td>
        </template>
        <template v-slot:body-cell-matricula="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.sapColaborador }}
          </q-td>
        </template>
        <template v-slot:body-cell-desvincular="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div class="q-ml-lg">
              <q-btn
                icon="close"
                color="red"
                round
                :disable="disable"
                @click="verificarValor(props.row.ativoUuid, true)"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-ml-md q-py-md">
      <q-timeline
        style="font-size: 20px"
        class="text-brand-5 text-weight-bold q-mb-lg"
        heading
      >
        <div
          style="font-size: 20px"
          class="text-brand-5 text-weight-bold q-mb-lg"
        >
          Histórico
        </div>
        <q-timeline-entry
          v-for="(log, index) in logsDocumento"
          :key="index"
          style="font-size: 16px"
          :title="
            log.titulo == 'documento_editar'
              ? 'Edição de Documento'
              : log.titulo == 'documento_criar'
              ? 'Criação de Documento'
              : log.titulo == 'documento_excluir'
              ? 'Exclusão do Documento'
              : log.titulo == 'documento_ativar'
              ? 'Documento Válido'
              : log.titulo == 'documento_desativar'
              ? 'Documento Obsoleto'
              : log.titulo == 'documento_revalidar'
              ? 'Documento Revalidado'
              : ''
          "
          :subtitle="
            gerarData(
              log.data.split(' ')[0].split('-').reverse().join('/'),
              log.data.split(' ')[1]
            )
          "
          icon="edit"
        >
          <div class="text-brand-5 text-weight-bold">
            <span
              v-if="
                log.descricao.includes('revalidado com sucesso') ||
                log.descricao.includes('revalidado de Documento')
              "
            >
              <router-link
                class="link"
                :to="{
                  name: 'documentos-detalhe',
                  params: {
                    uuid: log.descricao
                      .split('Documento')[2]
                      .split('|')[0]
                      .trim(),
                  },
                }"
                target="_blank"
              >
                {{
                  `${log.descricao} - ${log.usuarioNome} - ${log.usuarioMatricula}`
                }}
              </router-link>
            </span>
            <span v-else>
              {{
                `${log.descricao} - ${log.usuarioNome} - ${log.usuarioMatricula}`
              }}
            </span>
          </div>
        </q-timeline-entry>
      </q-timeline>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span style="font-size: 16px" v-if="tab == 'editar'">
              <span>
                <span v-if="detalheDocumento.nome.length > 30">
                  {{
                    `Editar Documento: ${detalheDocumento.nome.slice(
                      0,
                      28
                    )}...`
                  }}<q-tooltip>{{ detalheDocumento.nome }}</q-tooltip>
                </span>
                <span v-else>
                  {{ `Editar Documento: ${detalheDocumento.nome}`
                  }}<q-tooltip>{{ detalheDocumento.nome }}</q-tooltip>
                </span>
              </span>
            </span>
            <span style="font-size: 16px" v-if="tab == 'arquivo'">
              <span>
                <span v-if="detalheDocumento.nome.length > 30">
                  {{
                    `Upload de Arquivos: ${detalheDocumento.nome.slice(
                      0,
                      28
                    )}...`
                  }}<q-tooltip>{{ detalheDocumento.nome }}</q-tooltip>
                </span>
                <span v-else>
                  {{ `Upload de Arquivos: ${detalheDocumento.nome}`
                  }}<q-tooltip>{{ detalheDocumento.nome }}</q-tooltip>
                </span>
              </span>
            </span>
          </div>
        </div>
        <div class="col-12 justify-end">
          <div class="row col-2 justify-end">
            <q-tabs v-model="tab" narrow-indicator dense align="right">
              <q-tab class="text-black" no-caps name="editar" label="Editar" />
            </q-tabs>
          </div>
        </div>
        <div
          v-if="tab == 'editar'"
          class="column col-12 justify-between no-wrap"
          style="height: 80%"
        >
          <div class="q-px-md text-weight-bold">
            <div class="col-md-12 q-mt-xs">
              <div class="texto-titulo-input q-mb-xs">Nome</div>
              <q-input
                v-model="dadosDocumento.nome"
                dense
                outlined
                class="input"
                placeholder="Nome documento"
              />
            </div>
            <div class="row col-12 q-mt-sm">
              <div class="col-12 q-mr-sm">
                <div class="texto-titulo-input q-mb-xs">Data de Emissão</div>
                <q-input
                  v-model="dadosDocumento.dataVigencia"
                  dense
                  outlined
                  class="input"
                  placeholder="DD/MM/AAAA"
                  mask="##/##/####"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="dadosDocumento.dataVigencia"
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="row col-12 q-mt-sm">
              <div class="col-12 q-mr-sm">
                <div class="texto-titulo-input q-mb-xs">Data de Vencimento</div>
                <q-input
                  v-model="dadosDocumento.dataVencimento"
                  dense
                  outlined
                  class="input"
                  placeholder="DD/MM/AAAA"
                  mask="##/##/####"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="dadosDocumento.dataVencimento"
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="col-md-12 q-mt-md">
              <div class="texto-titulo-input q-mb-xs">
                Descrição do Documento
              </div>
              <q-input
                :input-style="{ maxHeight: '100px' }"
                v-model="dadosDocumento.descricao"
                outlined
                autogrow
                placeholder="Descrição"
              />
            </div>
            <div v-if="detalheDocumento.status != 'revalidado'" class="q-mt-sm">
              <q-btn
                v-if="detalheDocumento.status == 'valido'"
                color="red"
                label="Tornar Obsoleto"
                no-caps
                dense
                icon="cancel"
                @click="desativarDocumento()"
              />
              <q-btn
                v-else
                color="positive"
                label="Ativar"
                no-caps
                dense
                icon="check_circle_outlined"
                @click="ativarDocumento()"
              />
            </div>
          </div>
          <div class="q-px-md q-mt-sm q-pb-md">
            <q-btn
              dense
              icon="check_circle_outline"
              label="Salvar Alterações"
              no-caps
              color="positive"
              @click="editarDocumento()"
            />
          </div>
        </div>
      </q-card>
    </Transition>
    <q-dialog v-model="modalAtivos" full-width>
      <q-card style="height: 65vh">
        <q-card-section>
          <div class="row col-12 items-center justify-between">
            <div
              class="text-h6 row col-12 text-brand-5 text-weight-bold q-mb-md"
            >
              Ativos Criados
            </div>
            <div class="row col-12 justify-end">
              <ComponenteFiltros
                :unidade="true"
                :classUnidade="'col-md col-xs-6'"
                :fornecedor="true"
                :classFornecedor="'col-md col-xs-5'"
                :statusMovimentacao="true"
                :classStatusMovimentacao="'col-md col-xs-6'"
                :codigo="true"
                :classCodigo="'col-md col-xs-5'"
                :descricao="true"
                :classDescricao="'col-md col-xs-6'"
                :patrimonio="true"
                :classPatrimonio="'col-md col-xs-5'"
                :classGrupo="'col-md col-xs-6'"
                :subgrupo="true"
                :classSubgrupo="'col-md col-xs-5'"
                @enviarFiltro="receberFiltro"
              />
            </div>
          </div>
        </q-card-section>

        <div class="q-px-sm q-pt-none">
          <q-linear-progress v-if="loadingAtivos" indeterminate size="3px" />
          <q-table
            :columns="columnsAtivoVincular"
            :rows="listaFerramentas"
            color="primary"
            dense
            row-key="ativoUuid"
            class="my-sticky-dynamic-documento"
            hide-bottom
            selection="multiple"
            no-data-label="Nenhum ativo encontrado."
            hide-pagination
            flat
            table-header-class="bg-accent text-weight-bold"
            v-model:selected="selected"
            :rows-per-page-options="[0]"
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th
                  class="text-weight-bolder"
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr class="text-brand-5 text-weight-bold">
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.codigo }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.descricao }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.patrimonio }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{
                    `${props.row.status
                      .charAt(0)
                      .toUpperCase()}${props.row?.status.substring(1)}`
                  }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  <div class="q-ml-md">
                    <q-toggle
                      v-model="props.selected"
                      :disable="disableToggleAssociacao"
                      @click="
                        verificarValor(props.row.ativoUuid, props.selected)
                      "
                    />
                  </div>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="confirm" persistent>
      <q-card
        style="width: 590px"
        class="q-pa-sm text-brand-5 container-modal-excluir text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA ENVIAR O ARQUIVO "{{ file?.name }}"?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Enviar"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="enviarArquivo()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
            @click="file = null"
          />
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="confirmExcluir" persistent>
      <q-card
        style="width: 590px"
        class="q-pa-sm text-brand-5 container-modal-excluir text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >Você tem certeza que deseja excluir esse anexo?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            class="btn-excluir"
            no-caps
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="excluirArquivo()"
          />
          <q-btn
            class="btn-excluir q-ml-md"
            icon="cancel"
            no-caps
            label="Não"
            color="negative"
            v-close-popup
            @click="file = null"
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script setup>
import { useQuasar } from "quasar";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

import ComponenteFiltros from "../../ferramentaria/components/ComponenteFiltros.vue";
import SelecaoArquivoTela from "../components/SelecaoArquivoTela.vue";

const route = useRoute();
const store = useStore();
const router = useRouter();
const quasar = useQuasar();

const documentoUuid = route.params.uuid;
const rightDrawerOpen = ref(false);
const detalheDocumento = ref("");
const data = ref({
  dataVencimento: "",
  dataVigencia: "",
  dataEmissaoRevalidar: "",
  dataVencimentoRevalidar: "",
});
const loadingAtivos = ref(false);
const dados = ref({ categoria: "", tipo: "" });
const options = ref({ optionsTipo: [], optionsCategoria: [] });
const tab = ref("editar");
const dadosDocumento = ref("");
let file = ref(null);
let confirm = ref(false);
let confirmExcluir = ref(false);
let base64 = ref("");
let idArquivo = ref("");
const filter = ref("");
const logsDocumento = ref([]);
let revalidarDocumentoEditar = ref(false);
const filtros = ref({});
const listaAtivoVinculado = ref([]);
const listaFerramentas = ref([]);
const modalAtivos = ref(false);
const selected = ref([]);
const disableToggleAssociacao = ref(false);
const disable = ref(false);

const onFileSelected = async (e) => {
  if (e.target.files[0].length === 0) {
    return;
  }
  file.value = e.target.files[0];
  confirm.value = true;
};

const detalharDocumento = async () => {
  try {
    const response = await store.dispatch("documento/detalharDocumento", {
      uuid: documentoUuid,
    });
    detalheDocumento.value = response.data.resultado.dados;
    if (response.data.resultado.dados.status == "inativo") {
      detalheDocumento.value.status = "obsoleto";
    }
    listaAtivoVinculado.value = detalheDocumento.value.ativosVinculados;
    selected.value = [...listaAtivoVinculado.value];
    data.value = {
      dataVencimento: detalheDocumento.value.vencimento
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/"),
      dataVigencia: detalheDocumento.value.vigencia
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/"),
    };
    dados.value = {
      categoria: detalheDocumento.value.tipo.categoria,
      tipo: detalheDocumento.value.tipo,
    };
  } catch (error) {
    console.log(error);
  }
};

const voltar = () => {
  router.push({ name: "documentos-listar" });
};

const listarTipos = async (val) => {
  try {
    const response = await store.dispatch("documento/listarTipos", {
      unidadeId: store.state.org.unidadeData.id,
      categoriaUuid: "",
      nome: val,
      perPage: 100,
    });
    options.value.optionsTipo = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const listarCategorias = async (val) => {
  try {
    const response = await store.dispatch("documento/listarCategorias", {
      unidadeId: store.state.org.unidadeData.id,
      perPage: 100,
      nome: val,
    });
    options.value.optionsCategoria = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const editarDocumento = async () => {
  let dataVigencia = "";
  let dataVencimento = "";
  dataVigencia = dadosDocumento.value.dataVigencia;
  dataVencimento = dadosDocumento.value.dataVencimento;
  if (dataVigencia == "") {
    dataVigencia = data.value.dataVigencia;
  }
  if (dataVencimento == "") {
    const dataString = dataVigencia.split("/").reverse().join("-");
    const partes = dataString.split("-");
    const data = new Date(partes[0], partes[1] - 1, partes[2]);
    data.setDate(data.getDate() + detalheDocumento.value.tipo.validade);
    dataVencimento = data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
  try {
    const response = await store.dispatch("documento/editarDocumento", {
      uuid: documentoUuid,
      descricao: dadosDocumento.value.descricao,
      nome: dadosDocumento.value.nome,
      vigencia: `${dataVigencia.split("/").reverse().join("-")} 00:00:00`,
      vencimento: `${dataVencimento.split("/").reverse().join("-")} 00:00:00`,
    });
    if (response.data.resultado.message === "Documento já Revalidado.") {
      quasar.notify({
        message: "Não é permitido a edição no status revalidado.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      rightDrawerOpen.value = false;
      return;
    }
    quasar.notify({
      message: "Documento editado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    rightDrawerOpen.value = false;
    detalharDocumento();
  } catch (error) {
    quasar.notify({
      message: "Erro ao editar documento.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const listarAtivo = async () => {
  if (
    filtros.value.unidade?.id == "" ||
    filtros.value.unidade?.id == undefined
  ) {
    listaFerramentas.value = [];
    return;
  }
  try {
    loadingAtivos.value = true;
    const response = await store.dispatch("ferramentaria/listarAtivo", {
      perPage: 100,
      unidadeId: filtros.value.unidade?.id,
      catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
      comAcessorios: "sim",
      codigo: filtros.value?.codigo,
      patrimonio: filtros.value.patrimonio,
      status: filtros.value?.statusMovimentacao?.status,
      comCheckLists: "sim",
      comAtributos: "sim",
      nome: filtros.value?.descricao,
      nomeGrupo: filtros.value?.grupo?.nome,
      nomeSubgrupo: filtros.value?.subgrupo?.nome,
      comFornecedorAlocado:
        filtros.value?.fornecedor?.parceiroId != undefined &&
        filtros.value?.fornecedor?.parceiroId != "" &&
        filtros.value?.fornecedor?.parceiroId != null
          ? "sim"
          : undefined,
      fornecedorAlocado:
        filtros.value?.fornecedor?.parceiroId != undefined &&
        filtros.value?.fornecedor?.parceiroId != "" &&
        filtros.value?.fornecedor?.parceiroId != null
          ? filtros.value?.fornecedor?.parceiroId
          : undefined,
    });
    listaFerramentas.value = response.listaAtivo;
    loadingAtivos.value = false;
  } catch (error) {
    console.log(error);
    disable.value = false;
    loadingAtivos.value = false;
  }
};

const verificarValor = (documentoUuid, value) => {
  if (value) {
    if (
      store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
        "atv-ativo-documento-desvincular"
      ) == -1
    ) {
      quasar.notify({
        message: "Você não possui permissão para desvincular o ativo.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      return;
    }
    desvincularAtivo(documentoUuid);
    return;
  }
  if (
    store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
      "atv-ativo-documento-vincular"
    ) == -1
  ) {
    quasar.notify({
      message: "Você não possui permissão para vincular o ativo.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  vincularAtivo(documentoUuid);
};

const vincularAtivo = async (ativoUuid) => {
  try {
    disableToggleAssociacao.value = true;
    disable.value = true;
    await store.dispatch("ferramentaria/vincularDocumentoAtivo", {
      ativoUuid,
      documentoUuid: detalheDocumento.value.uuid,
    });
    detalharDocumento();
    disableToggleAssociacao.value = false;
    disable.value = false;
    quasar.notify({
      message: "Ativo vinculado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao vincular ativo",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    disableToggleAssociacao.value = false;
    disable.value = false;
  }
};

const desvincularAtivo = async (ativoUuid) => {
  try {
    disableToggleAssociacao.value = true;
    disable.value = true;
    await store.dispatch("ferramentaria/desvincularDocumentoAtivo", {
      ativoUuid,
      documentoUuid: detalheDocumento.value.uuid,
    });
    disableToggleAssociacao.value = false;
    disable.value = false;
    detalharDocumento();
    quasar.notify({
      message: "Ativo desvinculado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
    disableToggleAssociacao.value = false;
    disable.value = false;
    quasar.notify({
      message: "Erro ao desvincular ativo.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const enviarArquivo = async () => {
  try {
    await store.dispatch("documento/uploadArquivo", {
      conteudoBase64: base64.value,
      documentoUuid: documentoUuid,
      nome: retornarNomeArquivoValido(file.value.name),
    });
    rightDrawerOpen.value = false;
    detalharDocumento();
    file.value = null;
    quasar.notify({
      message: "Upload feito com sucessso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao fazer upload.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const excluirArquivo = async () => {
  try {
    await store.dispatch("documento/excluirArquivo", {
      uuid: idArquivo.value,
    });
    detalharDocumento();
    quasar.notify({
      message: "Arquivo excluido com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao excluir arquivo.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const logDocumento = async () => {
  try {
    const response = await store.dispatch("documento/logDocumento", {
      documentoUuid: documentoUuid,
    });
    logsDocumento.value = response.data.message;
  } catch (error) {
    console.log(error);
  }
};

const desativarDocumento = async () => {
  try {
    await store.dispatch("documento/desativarDocumento", {
      uuid: documentoUuid,
    });
    detalharDocumento();
    logDocumento();
    rightDrawerOpen.value = false;
    quasar.notify({
      message: "Documento ficou obsoleto.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao desativar documento.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const receberArquivo = (arquivo) => {
  file.value = arquivo[0];
  confirm.value = true;
};

const ativarDocumento = async () => {
  try {
    await store.dispatch("documento/ativarDocumento", {
      uuid: documentoUuid,
    });
    detalharDocumento();
    logDocumento();
    rightDrawerOpen.value = false;
    quasar.notify({
      message: "Documento foi ativado.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao ativar documento.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const abrirDialogoArquivo = () => {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.style.display = "none";
  fileInput.setAttribute("multiple", "");
  fileInput.addEventListener("change", onFileSelected);
  document.body.appendChild(fileInput);
  fileInput.click();
};

const retornarNomeArquivoValido = (nome) => {
  const regex = /[^a-zA-Z0-9._]/g;
  const stringValida = nome.replace(regex, "");

  return stringValida;
};

const receberFiltro = (value) => {
  filtros.value = value;
  listarAtivo();
};

watch(
  () => file.value,
  () => {
    if (file.value != null) {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file.value);
      fileReader.addEventListener("load", () => {
        base64.value = fileReader.result;
      });
    }
  }
);

watch(
  () => rightDrawerOpen.value,
  () => {
    if (rightDrawerOpen.value == false) {
      file.value = null;
      base64.value = "";
    }
  }
);

watch(
  () => modalAtivos.value,
  () => {
    if (modalAtivos.value == false) {
      listarAtivo();
    }
  }
);

const gerarData = (data, hora) => {
  const mes = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const dataPartes = data.split("/");
  const dia = parseInt(dataPartes[0], 10);
  const mesIndex = parseInt(dataPartes[1], 10) - 1;
  const year = parseInt(dataPartes[2], 10);

  const monthName = mes[mesIndex];

  return `${dia} de ${monthName} de ${year} - ${hora}`;
};

const revalidarDocumento = async () => {
  let vencimento = "";
  let vigencia = "";
  if (data.value?.dataVencimentoRevalidar) {
    vencimento = `${data.value?.dataVencimentoRevalidar
      .split("/")
      .reverse()
      .join("-")} 00:00:00`;
  }
  if (data.value?.dataEmissaoRevalidar) {
    vigencia = `${data.value?.dataEmissaoRevalidar
      .split("/")
      .reverse()
      .join("-")} 00:00:00`;
  }
  try {
    await store.dispatch("documento/revalidarDocumento", {
      uuid: documentoUuid,
      vencimento: vencimento,
      vigencia: vigencia,
    });
    data.value.dataVencimentoRevalidar = "";
    data.value.dataEmissaoRevalidar = "";
    detalharDocumento();
    logDocumento();
    revalidarDocumentoEditar.value = false;
    quasar.notify({
      message: "Documento revalidado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao revalidar documento.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(() => {
  detalharDocumento();
  logDocumento();
});

function filtrarTipo(val, update) {
  listarTipos(val);
  setTimeout(() => {
    update();
  }, 1000);
}
function filtrarCategoria(val, update) {
  listarCategorias(val);
  setTimeout(() => {
    update();
  }, 1000);
}
const myLocale = {
  days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
  daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
  months:
    "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
  monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
  firstDayOfWeek: 1,
};
const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: "nome",
  },
  {
    name: "criadoEm",
    label: "Criado Em",
    align: "left",
  },
  {
    name: "download",
    label: "Download",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
const columnsAtivo = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "nome",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "colaborador",
    label: "Colaborador",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula",
    align: "left",
  },
  {
    name: "desvincular",
    label: "Vincular/Desvincular",
    align: "left",
  },
];
const columnsAtivoVincular = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "nome",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "desvincular",
    label: "Vincular/Desvincular",
    align: "left",
  },
];
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.my-sticky-dynamic-documento {
  max-height: 400px;
}
tbody tr td {
  white-space: pre-wrap;
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: 100%;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
input[type="file"] {
  display: none;
}
.btn-upload {
  margin: 9px 0px 0px 0px;
}
a {
  text-decoration: none;
  color: white;
}
.link {
  color: #707070;
  font-weight: bold;
  text-decoration: underline;
}
.texto-upload {
  font-size: 12px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
